import { render, staticRenderFns } from "./ApiTable.vue?vue&type=template&id=029d00aa&scoped=true"
import script from "./ApiTable.vue?vue&type=script&lang=js"
export * from "./ApiTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029d00aa",
  null
  
)

export default component.exports